import http from '@/utils/services/http'

export default {
  lista (limit, page, filtros) {
    let url = `/api/usuarios?page=${page}&limit=${limit}${filtros}`
    return http.get(url)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/usuarios/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastro (data, id, params = null) {
    if (typeof id !== 'undefined') {
      return this.atualizacao(data, id, params)
    }
    return http.post(`/api/usuarios/${params && '?' + params}`, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacao (data, id, params = null) {
    return http.patch(`/api/usuarios/${id}${params && '?' + params}`, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deletar (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.delete('/api/usuarios/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  alterarSenha (senha, id) {
    return http.patch('/api/usuarios/' + id + '/password', senha)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  updatePrimeiroLogin (id) {
    return http.patch(`/api/usuarios/${id}/update-primeiro-login`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  adicionarACL (id, aclId, adicionar) {
    return http.patch('/api/usuarios/' + id + '/update-acl', {acl: aclId, adicionar})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  relacionarPatio (id, patioId, adicionar) {
    return http.patch('/api/usuarios/' + id + '/relaciona-patio', {patio: patioId, adicionar})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  relacionarContrato (id, contratoId, adicionar) {
    return http.patch('/api/usuarios/' + id + '/relaciona-contrato', {contrato: contratoId, adicionar})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  bloquear (id) {
    return http.patch(`/api/usuarios/${id}/bloquear`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  desbloquear (id) {
    return http.patch(`/api/usuarios/${id}/desbloquear`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  exportaRelatorio () {
    return http.get(`/api/usuarios/export`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/usuarios/services/index.js